module.exports = __webpack_public_path__ + "img/platform-5-icon.044270df.svg";